module.exports = __webpack_public_path__ + "img/gc.dfdcc52e.png";